import { makeRequest } from 'utils/requestLogger';

export default (participationID) =>
  makeRequest('post', `/api/participations/${participationID}/raise-hand`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/raiseHand.js